const EmptyState = () => {
  return (
    <div className="empty-state">
      <div className="empty-state-caption">
        <h5>PAGE TIDAK DITEMUKAN</h5>
        <p>Mohon maaf kami tidak bisa menemukan page yang kamu cari saat ini</p>
      </div>
    </div>
  );
};

export default EmptyState;
